import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const SignUp = lazy(() => import('components/Sections/SignUp'))
const Footer = lazy(() => import('components/Layout/Footer'))

function SignUpPage() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <SignUp />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default SignUpPage